module.exports = __webpack_public_path__ + "img/MAID-alt.15281be5.svg";